// extracted by mini-css-extract-plugin
export default {"productGrid":"U1-z","centerLink":"V1-z","productSection":"W1-z","item":"X1-z","ctaButton":"Y1-z"};